import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import * as theme from "../theme";
import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect } from "react";
import moment from "moment";
import Select from "react-select";
import SelectDropdown from "react-select";
import PerfectScrollbar from "react-perfect-scrollbar";
import { OrangeButton } from "../general/OrangeButton";

import "./reminder.css";
import "react-datepicker/dist/react-datepicker.css";
import {
  getOtherStatusModalState,
  reminderModalClosed,
  reminderOtherStatusClosed,
  reminderOtherStatusOpened,
} from "../store/components";
import { useDispatch, useSelector } from "react-redux";
import { FormateDate } from "../store/helperfuncs";
import { toast } from "react-toastify";
import CancelIcon from "@material-ui/icons/Cancel";
import { getBinders } from "../store/mybinder";
import { getBrokerInformation } from "../store/broker";
import { getBrokerTeamInfo, getBrokerTeamMembers } from "../store/quotes";
import { getQuotes } from "../store/myquotes";
import {
  POLICY,
  PROSPECT,
  CLIENT,
  NO_NAME_FOUND,
  INDIVIDUAL,
  GROUP,
  OPTION,
  clientPolicyProspectGroup,
  statusList,
  OTHER,
  getTranslatedOptions,
} from "../helper/constants";

import {
  createRemider,
  getCategoryList,
  getClientDetailsForReminders,
  getClientListData,
  getCreatedReminderResponse,
  getGroupSelectArray,
  getMyReminders,
  getReminderSingleObject,
  reminderSingleObjectClear,
  updateReminderStatus,
  getreminderStatusUpdate,
} from "../store/myreminder";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import fr from "date-fns/locale/fr";

const translations = {
  en: {
    updateReminder: "Update Reminder",
    createNewReminder: "Create New Reminder",
    reminderTitle: "Reminder Title",
    titleOfReminder: "Title of reminder",
    reminderForMe: "Reminder For Me",
    status: "Status",
    selectAnOption: "Select an option",
    individualOrTeam: "Individual or Team",
    owner: "Owner",
    reminderFor: "Reminder For",
    selectAnOptionEllipsis: "Select an option...",
    category: "Category",
    selectADate: "Select a date",
    description: "Description",
    descriptionOfReminder: "Description of reminder",
    sendEmailNotificationToOwner: "Send email notification to owner",
    reminderDate: "Reminder Date",
  },
  fr: {
    updateReminder: "Mettre à jour le rappel",
    createNewReminder: "Créer un nouveau rappel",
    reminderTitle: "Nom du rappel",
    titleOfReminder: "Titre du rappel",
    reminderForMe: "Rappel pour moi",
    status: "Statut",
    selectAnOption: "Sélectionner une option",
    individualOrTeam: "Assigné à",
    owner: "Nom du client",
    reminderFor: "Rappel relié à ",
    selectAnOptionEllipsis: "Sélectionner une option...",
    category: "Étape",
    selectADate: "Sélectionner une date",
    description: "Description",
    descriptionOfReminder: "Description du rappel",
    sendEmailNotificationToOwner: "Envoyer courriel au propriétaire du rappel",
    reminderDate: "Date du suivi",
  },
};

const ReminderModal = (props) => {
  const dispatch = useDispatch();
  //data get from selectors.
  const brokerteam = useSelector(getBrokerTeamMembers);
  const clientDataForReminder = useSelector(getClientDetailsForReminders);
  const clientListArray = useSelector(getClientListData);
  const createAPIResp = useSelector(getCreatedReminderResponse);
  const groupList = useSelector(getGroupSelectArray);
  const prospectArray = useSelector(getQuotes);
  const binderPolicyArray = useSelector(getBinders);
  const prospects = prospectArray?.prospectorder;
  const binders = binderPolicyArray?.prospectorder;
  const categories = useSelector(getCategoryList);
  const reminderSingleObj = useSelector(getReminderSingleObject);
  const { information } = useSelector(getBrokerInformation);

  const [teamDropdownflag, setTeamDropDownflag] = useState(false);
  const [clientPolicyFlag, setClientPolicyFlag] = useState(false);
  const [checked, setChecked] = useState(false);

  const [clientPolicyDefaultList, setClientPolicyDefaultList] = useState([]);
  const [individualGroupList, setIndividualGroupList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [title, setTitle] = useState("");
  const [isReminder, setIsReminder] = useState(false);
  const [description, setDescription] = useState("");
  const [selectedTeamOption, setSelectedTeamOption] = useState(null);
  const [clientPolicyGroup, setClientPolicyGroup] = useState(null);
  const [categorySelect, setCategorySelect] = useState(null);
  const [ownerType, setOwnerType] = useState(null);
  const [clientPolicyName, setClientPolicyName] = useState(null);
  // validation error state here...
  const [reminderTitleError, setReminderTitleError] = useState("");
  const [ownerTypeError, setOwnerTypeError] = useState("");
  const [reminderForError, setReminderForError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [reminderDateError, setReminderDateError] = useState("");
  const [ownerError, setOwnerError] = useState("");
  const [clientError, setClientError] = useState("");
  const upadateStatusResponse = useSelector(getreminderStatusUpdate);
  const [note, setNote] = useState("");
  const otherReminderModal = useSelector(getOtherStatusModalState);
  const brokerage = useSelector(getBrokerInformation);
  const languagePreference = brokerage.information.languagepreference || "en";
  const style = {
    minHeight: "2vh",
    fontSize: "1.8vmin",
    fontFamily: "GibsonRegular",
  };
  const otherStatusModalOpenHandler = (e, reminder) => {
    const updateReminderObject = {
      reminderId: reminder?._id,
      status: e.value,
    };
    if (e.value === OTHER) {
      dispatch(reminderOtherStatusOpened());
    } else {
      dispatch(updateReminderStatus(updateReminderObject)).then(() => {
        dispatch(getMyReminders());
      });
      setTimeout(() => {
        if (upadateStatusResponse) {
          toast.success(upadateStatusResponse.message);
          // dispatch(reminderSingleObjectClear());
        }
      }, 200);
    }
  };
  <Modal
    isOpen={otherReminderModal}
    ariaHideApp={false}
    shouldCloseOnEsc={false}
    style={{
      overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme.COLORS.rgba_primary_navyblue,
        color: "white",
      },
      content: {
        height: "60%",
        width: "36vw",
        position: "absolute",
        top: "18vh",
        left: "28vw",
        right: 0,
        bottom: 0,
        background: "white",
        WebkitOverflowScrolling: "touch",
        border: `8px solid white`,
        borderRadius: "20px",
        padding: 0,
        overflow: "hidden",
      },
    }}
  >
    <OtherStatusModal note={note} setNote={setNote}></OtherStatusModal>
  </Modal>;
  const customStyles = {
    control: (provided) => ({
      ...provided,
      color: "red", // replace 'red' with your desired font color
      borderWidth: "2px",
      borderColor: "rgb(73, 168, 214) ",
      "&:hover": {
        borderColor: "rgb(73, 168, 214)",
      },
    }),
    option: (provided) => ({
      ...provided,
      color: "rgb(63, 68, 90)", // replace 'blue' with your desired font color for options
    }),
  };
  const heights = {
    desc: "8%",
    proceedbutton: "8%",
    somegapbetween: "2%",
    remainingHeight: "",
  };
  const hDist = {
    headingHeight: "10%",
    remainingHeight: "10%",
  };
  hDist.remainingHeight = `calc(100% - ${hDist.headingHeight})`;
  heights.remainingHeight = `calc(100% - ${heights.desc} - ${heights.proceedbutton} - ${heights.somegapbetween})`;
  // object for create reminder
  const createReminderObject = {
    title: title,
    description: description,
    ownertype: ownerType?.value,
    owner: selectedTeamOption?.value,
    remindertype: clientPolicyName?.value,
    clientid:
      clientPolicyName?.value == CLIENT ? clientPolicyGroup?.value : null,
    policyid:
      clientPolicyName?.value == POLICY ? clientPolicyGroup?.value : null,
    prospectid:
      clientPolicyName?.value == PROSPECT ? clientPolicyGroup?.value : null,
    remindercategory: categorySelect?.value,
    reminderdate: startDate,
    archive: false,
    deleted: false,
    sendemail: checked,
    languagepreference:languagePreference
  };
  //object for update reminder
  const updateReminderObject = {
    _id: reminderSingleObj?._id,
    title: title,
    description: description,
    ownertype: ownerType?.value,
    owner: selectedTeamOption?.value,
    remindertype: clientPolicyName?.value,
    clientid:
      clientPolicyName?.value == CLIENT ? clientPolicyGroup?.value : null,
    policyid:
      clientPolicyName?.value == POLICY ? clientPolicyGroup?.value : null,
    prospectid:
      clientPolicyName?.value == PROSPECT ? clientPolicyGroup?.value : null,
    remindercategory: categorySelect?.value,
    reminderdate: startDate,
    archive: false,
    deleted: false,
    sendemail: checked,
    languagepreference:languagePreference
  };
  const useStyles = makeStyles(
    theme.customMaterialUIClassForScrollBarDarkBackgrond
  );
  const classes = useStyles();

  const handelSelectedValue = (array, string) => {
    return array.find((a) => a.value == string);
  };
  // for bind selected category
  useEffect(() => {
    const allCategory = categories.map((item) => {
      return {
        value: item.code,
        label: item?.title,
      };
    });
    setCategorySelect(
      handelSelectedValue(allCategory, reminderSingleObj.remindercategory)
    );
    setCategoryList(allCategory);
  }, [categories]);

  useEffect(() => {
    if (ownerType?.value == INDIVIDUAL) {
      setTeamDropDownflag(true);
    }
    if (ownerType?.value == GROUP) {
      setTeamDropDownflag(true);
    }
    if (
      clientPolicyName?.value == POLICY ||
      clientPolicyName?.value == PROSPECT ||
      clientPolicyName?.value == CLIENT
    ) {
      setClientPolicyFlag(true);
    }
  });
  useEffect(() => {
    setTitle(reminderSingleObj?.title);
    setStartDate(
      reminderSingleObj?.reminderdate &&
        new Date(reminderSingleObj?.reminderdate)
    );
    setOwnerType(handelSelectedValue(OPTION, reminderSingleObj?.ownertype));
    setChecked(reminderSingleObj?.sendemail);
    setClientPolicyName(
      handelSelectedValue(
        clientPolicyProspectGroup,
        reminderSingleObj?.remindertype
      )
    );
    setDescription(reminderSingleObj?.description);
  }, [reminderSingleObj?._id]);

  useEffect(() => {
    let remType = reminderSingleObj?.remindertype;
    if (remType == CLIENT) {
      const client = clientListArray?.map((clientData) => {
        return { value: clientData?.id, label: clientData?.name };
      });
      setClientPolicyDefaultList(client);
      setClientPolicyGroup(
        handelSelectedValue(client, reminderSingleObj?.clientid)
      );
    } else if (remType == POLICY) {
      const policy = binders.map((polData) => {
        return { value: polData?._id, label: polData?.CLIENT_NAME };
      });
      setClientPolicyGroup(
        handelSelectedValue(policy, reminderSingleObj.policyid)
      );
      setClientPolicyDefaultList(policy);
    } else if (remType == PROSPECT) {
      const prospect = prospects?.map((item) => {
        return { value: item?.prospectid, label: item?.CLIENT_NAME };
      });
      setClientPolicyGroup(
        handelSelectedValue(prospect, reminderSingleObj.prospectid)
      );
      setClientPolicyDefaultList(prospect);
    }
  }, [reminderSingleObj.remindertype]);

  useEffect(async () => {
    let ownerType = reminderSingleObj?.ownertype;
    if (ownerType == INDIVIDUAL) {
      let individual =
        (await brokerteam) &&
        brokerteam?.brokers.map((indiv) => {
          return {
            value: indiv?._id,
            label: `${indiv?.firstname} ${indiv?.lastname}`,
          };
        });
      setSelectedTeamOption(
        handelSelectedValue(individual, reminderSingleObj.owner)
      );
      setIndividualGroupList(individual);
    } else if (ownerType == GROUP) {
      let group = await groupList.map((grpVal) => {
        return {
          value: grpVal?._id,
          label: grpVal?.title,
        };
      });
      setIndividualGroupList(group);
      setSelectedTeamOption(
        handelSelectedValue(group, reminderSingleObj.owner)
      );
    }
  }, [reminderSingleObj.ownertype]);
  // create or update reminder
  const createUpdateReminderData = async () => {
    try {
      const data = reminderSingleObj?._id
        ? updateReminderObject
        : createReminderObject;
      if (
        (title === "" || title === undefined) &&
        (ownerType === "" || ownerType === undefined) &&
        (categorySelect === "" || categorySelect === undefined) &&
        (clientPolicyName === "" || clientPolicyName === undefined) &&
        (startDate == "" || startDate == undefined)
      ) {
        setReminderTitleError("Please fill this field");
        setOwnerTypeError("Owner type required");
        setCategoryError("Please Select Category");
        setReminderForError("Please Select Reminder For");
        setReminderDateError("Reminder date is required");
      }
      if (title === "" || title === undefined) {
        setReminderTitleError("Please fill this field");
      } else if (ownerType === "" || ownerType === undefined) {
        setOwnerTypeError("Owner type required");
      } else if (categorySelect === "" || categorySelect === undefined) {
        setCategoryError("Please Select Category");
      } else if (clientPolicyName === "" || clientPolicyName === undefined) {
        setReminderForError("Please Select Reminder For");
      } else if (startDate == "" || startDate == undefined) {
        setReminderDateError("Reminder date is required");
      } else if (
        (teamDropdownflag && selectedTeamOption == "") ||
        (teamDropdownflag && selectedTeamOption == undefined)
      ) {
        setOwnerError("Please Select Owner ");
      } else if (
        (clientPolicyFlag && clientPolicyGroup == "") ||
        (clientPolicyFlag && clientPolicyGroup == undefined)
      ) {
        setClientError("Please Select Client");
      } else {
        dispatch(createRemider({ reminder: data }));
        if (data._id) {
          toast.success("Reminder updated successfully");
        } else {
          toast.success("Reminder created");
        }
        await dispatch(getMyReminders());
        await dispatch(reminderModalClosed());
      }
    } catch (error) {
      console.error("error");
    }
  };

  const handleCloseButton = () => {
    dispatch(reminderModalClosed());
    dispatch(reminderSingleObjectClear());
  };

  const groupIndividualChangeHandler = async (name) => {
    setOwnerTypeError("");
    if (name == INDIVIDUAL) {
      let individual =
        (await brokerteam) &&
        brokerteam.brokers.map((indiv) => {
          return {
            value: indiv?._id,
            label: `${indiv?.firstname} ${indiv?.lastname}`,
          };
        });
      setIndividualGroupList(individual);
    } else if (name == GROUP) {
      let group = await groupList.map((grpVal) => {
        return {
          value: grpVal?._id,
          label: grpVal?.title,
        };
      });
      setIndividualGroupList(group);
    }
  };

  const clientPolicyHandler = async (name) => {
    if (name == CLIENT) {
      const client = await clientListArray?.map((clientData) => {
        return {
          value: clientData?.id,
          label: clientData?.name || NO_NAME_FOUND,
        };
      });
      setClientPolicyDefaultList(client);
    } else if (name == POLICY) {
      const policy = await binders.map((polData) => {
        return {
          value: polData?._id,
          label: polData?.CLIENT_NAME || NO_NAME_FOUND,
        };
      });
      setClientPolicyDefaultList(policy);
    } else if (name == PROSPECT) {
      const prospect = await prospects.map((item) => {
        return {
          value: item?.prospectid,
          label: item?.CLIENT_NAME || NO_NAME_FOUND,
        };
      });
      setClientPolicyDefaultList(prospect);
    }
  };

  const handleToggle = () => {
    setChecked(!checked);
  };
  return (
    <>
      <CommonModalForConfiguration
        heading={
          reminderSingleObj?._id
            ? translations[languagePreference].updateReminder
            : translations[languagePreference].createNewReminder
        }
        handleCloseButton={handleCloseButton}
        classes={classes}
        heights={heights}
        hDist={hDist}
        button={reminderSingleObj?._id}
        createUpdateReminderData={createUpdateReminderData}
      >
        <div className="mt-4"></div>
        <form>
          <CommonInputField
            label={translations[languagePreference].reminderTitle}
            placeholder={translations[languagePreference].titleOfReminder}
            onChange={(e) => {
              setReminderTitleError("");
              setTitle(e.target.value);
            }}
            value={title}
          ></CommonInputField>
          {reminderTitleError ? (
            <small
              style={{
                color: "#f92a2afc",
                marginLeft: "30%",
              }}
            >
              {reminderTitleError}
            </small>
          ) : null}
          <CommonInputSwitchField
            label={translations[languagePreference].reminderForMe}
            handleToggle={(e) => {
              setIsReminder(!isReminder);
              setOwnerType(handelSelectedValue(OPTION, INDIVIDUAL));
              setSelectedTeamOption({ value: information._id });
            }}
            id="customSwitch22"
            checked={isReminder}
          ></CommonInputSwitchField>
          {/* /// */}
          {reminderSingleObj?._id && (
            <section className="section-dropdown">
              <div className="section-label-dropdown">
                {translations[languagePreference].status}
              </div>
              <div className="section-inputbox">
                <Select
                  className="form-select"
                  placeholder={translations[languagePreference].selectAnOption}
                  defaultValue={getTranslatedOptions(
                    statusList.find(
                      (s) => s.value == reminderSingleObj?.status
                    ),
                    languagePreference
                  )}
                  onChange={(e) => {
                    otherStatusModalOpenHandler(e, reminderSingleObj);
                  }}
                  styles={customStyles}
                  options={getTranslatedOptions(statusList, languagePreference)}
                />
              </div>
            </section>
          )}
          {/* //// */}
          {!isReminder && (
            <section className="section-dropdown">
              <div className="section-label-dropdown">
                {translations[languagePreference].individualOrTeam}
              </div>
              <div className="section-inputbox">
                <Select
                  className="form-select"
                  value={ownerType}
                  getOptionLabel={(option) => option.label[languagePreference]}
                  onChange={(e) => {
                    setTeamDropDownflag(true);
                    setSelectedTeamOption(null);

                    setOwnerType(e);
                    groupIndividualChangeHandler(e.value);
                  }}
                  placeholder={translations[languagePreference].selectAnOption}
                  options={OPTION}
                  styles={customStyles}
                />
              </div>
            </section>
          )}
          {ownerTypeError ? (
            <small
              style={{
                color: "#f92a2afc",
                marginLeft: "30%",
              }}
            >
              {ownerTypeError}
            </small>
          ) : null}

          {teamDropdownflag && !isReminder && (
            <>
              <section className="section-dropdown">
                <div className="section-label-dropdown">
                  {translations[languagePreference].owner}
                </div>
                <div className="section-inputbox">
                  <Select
                    className="form-select"
                    placeholder={
                      translations[languagePreference].selectAnOption
                    }
                    value={selectedTeamOption}
                    onChange={(e) => {
                      setOwnerError("");
                      setSelectedTeamOption(e);
                    }}
                    options={individualGroupList}
                    styles={customStyles}
                  />
                </div>
              </section>
              {teamDropdownflag && ownerError ? (
                <small
                  style={{
                    color: "#f92a2afc",
                    marginLeft: "30%",
                  }}
                >
                  {ownerError}
                </small>
              ) : null}
            </>
          )}
          {/* policy or prospect or client dropdown */}
          <section className="section-dropdown">
            <div className="section-label-dropdown">
              {translations[languagePreference].reminderFor}
            </div>
            <div className="section-inputbox">
              <Select
                className="form-select"
                onChange={(e) => {
                  setReminderForError("");
                  setClientPolicyName(e);
                  setClientPolicyGroup(null);
                  setClientPolicyFlag(true);
                  clientPolicyHandler(e.value);
                }}
                options={clientPolicyProspectGroup}
                getOptionLabel={(option) => option.label[languagePreference]}
                value={clientPolicyName}
                placeholder={
                  translations[languagePreference].selectAnOptionEllipsis
                }
                styles={customStyles}
              />
            </div>
          </section>
          {reminderForError ? (
            <small
              style={{
                color: "#f92a2afc",
                marginLeft: "30%",
              }}
            >
              {reminderForError}
            </small>
          ) : null}
          {/* 2nd dropdown condition based */}
          {clientPolicyFlag && (
            <>
              <section className="section-dropdown">
                <div className="section-label-dropdown">
                  {clientPolicyName?.label}
                </div>
                <div className="section-inputbox">
                  <Select
                    className="form-select"
                    value={clientPolicyGroup}
                    onChange={(e) => {
                      setClientError("");
                      setClientPolicyGroup(e);
                    }}
                    options={clientPolicyDefaultList}
                    styles={customStyles}
                  />
                </div>
              </section>
              {clientPolicyFlag && clientError ? (
                <small
                  style={{
                    color: "#f92a2afc",
                    marginLeft: "30%",
                  }}
                >
                  {clientError}
                </small>
              ) : null}
            </>
          )}
          <section className="section-dropdown">
            <div className="section-label-dropdown">
              {translations[languagePreference].category}
            </div>
            <div className="section-inputbox">
              <Select
                className="form-select"
                placeholder={translations[languagePreference].selectAnOption}
                value={categorySelect}
                onChange={(e) => {
                  setCategoryError("");
                  setCategorySelect(e);
                }}
                styles={customStyles}
                options={categoryList}
              />
            </div>
          </section>
          {categoryError ? (
            <small
              style={{
                color: "#f92a2afc",
                marginLeft: "30%",
              }}
            >
              {categoryError}
            </small>
          ) : null}
          <CommonInputDatePickerField
            label={translations[languagePreference].reminderDate}
            setStartDate={setStartDate}
            setReminderDateError={setReminderDateError}
            startDate={startDate}
            placeholderText={translations[languagePreference].selectADate}
          ></CommonInputDatePickerField>
          {reminderDateError ? (
            <small
              style={{
                color: "#f92a2afc",
                marginLeft: "30%",
              }}
            >
              {reminderDateError}
            </small>
          ) : null}
          <CommonInputTextArea
            label={translations[languagePreference].description}
            placeholder={translations[languagePreference].descriptionOfReminder}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          ></CommonInputTextArea>

          <CommonInputSwitchField
            label={
              translations[languagePreference].sendEmailNotificationToOwner
            }
            handleToggle={handleToggle}
            checked={checked}
            id="customSwitch"
          ></CommonInputSwitchField>
        </form>
      </CommonModalForConfiguration>
    </>
  );
};

const CommonInputField = ({
  label = "Sample common label",
  onChange,
  value,
  placeholder,
  required,
}) => {
  return (
    <section className="section-input-label">
      <div className="common-input-field-label">{label}</div>
      <div className="section-inputbox">
        <input
          className="common-input-textarea-field"
          style={{
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${theme.COLORS.secondary_skyblue}`,
          }}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        ></input>
      </div>
    </section>
  );
};
const CommonInputCheckBoxField = ({
  label = "Sample common label",
  onChange,
  value,
  placeholder,
  required,
}) => {
  return (
    <section className="section-input-label ">
      <input
        type="checkbox"
        className="common-input-check"
        // checked
        onChange={onChange}
        placeholder={placeholder}
        style={{
          color: theme.COLORS.dark_navy_blue,
          border: `2px solid ${theme.COLORS.secondary_skyblue}`,
        }}
      />
      <div className="common-input-check">{label}</div>
    </section>
  );
};
const CommonInputSwitchField = ({
  label = "Sample common label",
  onChange,
  value,
  placeholder,
  required,
  handleToggle,
  checked,
  id,
}) => {
  return (
    <section className="section-input-label-switch ">
      <div className="section-inputbox">
        <div className="custom-control custom-switch custom-switch-lg">
          <input
            type="checkbox"
            className="custom-control-input"
            id={id}
            checked={checked}
            onChange={handleToggle}
          />
          <label className="custom-control-label" htmlFor={id}>
            {label}
          </label>
        </div>
      </div>
    </section>
  );
};
const CommonInputDatePickerField = ({
  label = "Sample common label",
  onChange,
  value,
  placeholderText,
  startDate,
  setStartDate,
  setReminderDateError,
}) => {
  const brokerage = useSelector(getBrokerInformation);
  const languagePreference = brokerage.information.languagepreference || "en";
  return (
    <section className="section-input-label">
      <div className="section-label-dropdown">{label}</div>
      <div style={{ minHeight: "100%" }}>
        <DatePicker
          selected={startDate}
          onChange={(date) => {
            setReminderDateError("");
            setStartDate(date);
          }}
          placeholderText={placeholderText}
          className="my-datepicker"
          showTimeSelect
          timeFormat="HH:mm"
          timeIntervals={15}
          timeCaption={languagePreference === "fr" ? "Heure" : "Time"}
          dateFormat={
            languagePreference === "fr"
              ? "d MMMM yyyy à H:mm aa"
              : "MMMM d, yyyy h:mm aa"
          }
          locale={languagePreference === "fr" ? fr : undefined}
        />
      </div>
    </section>
  );
};
const CommonInputTextArea = ({
  label = "Sample label",
  onChange,
  value,
  placeholder,
}) => {
  return (
    <section className="section-input-label">
      <div className="common-input-textarealabel">{label}</div>
      <div className="section-inputbox">
        <textarea
          className="common-input-textarea-field"
          style={{
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${theme.COLORS.secondary_skyblue}`,
          }}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        ></textarea>
      </div>
    </section>
  );
};
const OtherStatusModal = ({ note, setNote }) => {
  const dispatch = useDispatch();
  const reminderSingleObj = useSelector(getReminderSingleObject);
  const upadateStatusResponse = useSelector(getreminderStatusUpdate);
  useEffect(() => {
    setNote(reminderSingleObj.note);
  }, [reminderSingleObj]);
  const otherStatusUpdate = () => {
    const updateReminderObject = {
      reminderId: reminderSingleObj?._id,
      status: OTHER,
      note: note,
    };
    dispatch(updateReminderStatus(updateReminderObject)).then(async () => {
      await dispatch(reminderOtherStatusClosed());
      // await dispatch(getMyReminders());
    });
    toast.success(upadateStatusResponse.message);
    // dispatch(reminderSingleObjectClear());
  };
  const classes = useStyles();
  const heights = {
    desc: "8%",
    proceedbutton: "8%",
    somegapbetween: "2%",
    remainingHeight: "",
  };
  const hDist = {
    headingHeight: "10%",
    remainingHeight: "10%",
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
        }}
      >
        <div
          style={{
            height: hDist.headingHeight,
            width: "100%",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: theme.COLORS.secondary_skyblue,
              fontSize: "3vmin",
              letterSpacing: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              fontFamily: "GibsonRegular",
            }}
          >
            Add Notes
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
            backgroundColor: theme.COLORS.primary_navyblue,
            padding: "2vmin",
            paddingTop: 0,
          }}
        >
          <div className="cross-icon-position">
            <CancelIcon
              fontSize="large"
              className="cross-icon-style"
              onClick={() => {
                dispatch(reminderOtherStatusClosed());
                dispatch(reminderSingleObjectClear());
              }}
            ></CancelIcon>
          </div>
          <PerfectScrollbar>
            <div className="form-group row note-modal-section">
              <label className="font-weight-bold col-form-label text-warning">
                Client Name :
              </label>
              <label className="col-sm-3 col-form-label">
                {reminderSingleObj?.clientName}
              </label>
              <label className="font-weight-bold col-form-label text-warning">
                Creator Name :
              </label>
              <label className="col-sm-3 col-form-label">
                {reminderSingleObj?.creatorName}
              </label>
            </div>
            <div className="form-group row note-modal-section ">
              <label className="font-weight-bold col-form-label text-warning">
                Owner Name :
              </label>
              <label className="col-sm-3 col-form-label">
                {reminderSingleObj?.ownerName}
              </label>
              <label className=" font-weight-bold col-form-label text-warning">
                Owner Type :
              </label>
              <label className="col-sm-3 col-form-label">
                {reminderSingleObj?.ownertype}
              </label>
            </div>
            <div>
              <CommonInputTextArea
                placeholder="Add notes here...."
                value={note}
                onChange={(e) => setNote(e.target.value)}
              ></CommonInputTextArea>
              <OrangeButton
                onClick={otherStatusUpdate}
                text="Update"
                width="100%"
              ></OrangeButton>
            </div>
          </PerfectScrollbar>
        </div>
      </div>
    </>
  );
};
const CommonModalForConfiguration = ({
  heading,
  subHeading,
  handleCloseButton,
  classes,
  button,
  heights,
  hDist,
  children,
  createUpdateReminderData,
  binderLetterStatus,
}) => {
  const dispatch = useDispatch();
  const brokerage = useSelector(getBrokerInformation);
  const languagePreference = brokerage.information.languagepreference || "en";
  useEffect(() => {
    const onKeyPressed = (e) => {
      if (e.keyCode === 27) {
        dispatch(reminderModalClosed());
      }
    };
    document.addEventListener("keydown", onKeyPressed);

    return () => {
      document.removeEventListener("keydown", onKeyPressed);
    };
  }, []);
  return (
    <div className="common-modal-config">
      <div
        style={{
          height: hDist.headingHeight,
          width: "100%",
        }}
      >
        <div
          className="common-modal-config-header"
          style={{
            backgroundColor: theme.COLORS.secondary_skyblue,
          }}
        >
          {heading}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: hDist.remainingHeight,
          backgroundColor: theme.COLORS.primary_navyblue,
          padding: "2vmin",
          paddingTop: 0,
        }}
      >
        <div className="cross-icon-position">
          <CancelIcon
            fontSize="large"
            className="cross-icon-style"
            onClick={handleCloseButton}
          ></CancelIcon>
        </div>

        <div className="modal-height-align">
          <div className="modal-padding"></div>

          <div
            style={{
              width: "100%",
              height: heights.remainingHeight,
              fontSize: "1.9vmin",
              letterSpacing: 1,
              overflow: "auto",
            }}
            className={classes.responses}
          >
            {children}
          </div>
          <div className="modal-align"></div>
          <div
            className="modal-submit-button"
            style={{
              height: heights.proceedbutton,
              backgroundColor: theme.COLORS.secondary_orange,
            }}
            onClick={() => {
              createUpdateReminderData();
            }}
          >
            <div>
              {button
                ? translations[languagePreference].updateReminder
                : translations[languagePreference].createNewReminder}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReminderModal;
